import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS, MatDateFormats } from "@angular/material";


export class AppDateAdapter extends NativeDateAdapter {
    parse(value: any): Date | null {
        const translate = localStorage.getItem('LOCALIZE_DEFAULT_LANGUAGE')
        if ((typeof value === 'string') && (value.indexOf('/') > -1)) {
            const str = value.split('/');
            // const year = Number(str[2]);
            // const month = Number(str[1]) - 1;
            // const date = Number(str[0]);
            const dateFormats = str[0] + str[1] + (str[2] == undefined ? NaN : str[2])
            const date = Number(dateFormats.slice(0, 2))
            const month = Number(dateFormats.slice(2, 4)) - 1
            const year = Number(dateFormats.slice(4))
            if (translate == 'th') {
                return new Date(year - 543, month, date);
            } else {
                return new Date(year, month, date);
            }
        }
        const timestamp = typeof value === 'number' ? value : Date.parse(value);
        return isNaN(timestamp) ? null : new Date(timestamp);
    }
    format(date: Date, displayFormat: string): string {
        const translate = localStorage.getItem('LOCALIZE_DEFAULT_LANGUAGE')
        if (displayFormat == "input") {
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year;
            if (translate == 'th') {
                year = date.getFullYear() + 543;
            } else {
                year = date.getFullYear();
            }
            return this._to2digit(day) + '/' + this._to2digit(month) + '/' + year;
        } else if (displayFormat == "inputMonth") {
            let month = date.getMonth() + 1;
            let year;
            if (translate == 'th') {
                year = date.getFullYear() + 543;
            } else {
                year = date.getFullYear();
            }
            return this._to2digit(month) + '/' + year;
        } else {
            return date.toDateString();
        }
    }

    private _to2digit(n: number) {
        return ('00' + n).slice(-2);
    }
}

export const APP_DATE_FORMATS =
{
    parse: {
        dateInput: { month: 'short', year: 'numeric', day: 'numeric' }
    },
    display: {
        // dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
        dateInput: 'input',
        // monthYearLabel: { month: 'short', year: 'numeric', day: 'numeric' },
        monthYearLabel: 'inputMonth',
        dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    }
}